import script from "./memberCreate.vue?vue&type=script&setup=true&lang=js"
export * from "./memberCreate.vue?vue&type=script&setup=true&lang=js"

import "./memberCreate.vue?vue&type=style&index=0&id=78fa027c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78fa027c"]])

export default __exports__